import { MainLayout } from 'components';
import { Helmet } from 'react-helmet-async';
import { Navigate, Outlet, RouteObject, useRoutes } from 'react-router-dom';
import PrivateRoute from 'routers/PrivateRoute';
import { APP_ROUTES } from 'routers/routes';
import AuthFeature from './auth';
import { EditJob, JobDetail, ListJobs, PaymentJobs } from './bookings';
import CreateRequest from './create-request';
import { ConvertPDFtoHTML } from './create-request/components/RequestDetail/components/PDFs';
import { BuyCredits, OverviewCredits, PaymentCredits } from './credits';
import HowItWorks from './how-it-works';
import NotificationPage from './notifications';
import Overview from './overview';
import { EditProfile } from './profile';
import SitterDetail from './sitter-detail';

const configRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.AUTH.path,
    element: <AuthFeature />,
  },
  {
    path: APP_ROUTES.SITTER_DETAIL.path,
    element: (
      <PrivateRoute>
        <SitterDetail />
      </PrivateRoute>
    ),
  },
  {
    path: APP_ROUTES.SERVICE_ASSESSMENT.path,
    element: (
      <PrivateRoute>
        <ConvertPDFtoHTML />
      </PrivateRoute>
    ),
  },
  {
    path: '*',
    element: (
      <PrivateRoute>
        <MainLayout />
        <Helmet>
          <title>Aunty Concierge</title>
          <meta name="description" content="Aunty Concierge" />
        </Helmet>
      </PrivateRoute>
    ),
    children: [
      {
        path: APP_ROUTES.HOW_IT_WORKS.path,
        element: <HowItWorks />,
      },
      {
        path: APP_ROUTES.CREATE_REQUEST.path,
        element: <CreateRequest />,
      },
      {
        path: APP_ROUTES.OVERVIEW.path,
        element: <Overview />,
      },
      {
        path: APP_ROUTES.NOTIFICATIONS.path,
        element: <NotificationPage />,
      },
      {
        path: APP_ROUTES.JOB.path,
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <ListJobs />,
          },
          {
            path: APP_ROUTES.JOB.DETAIL.path,
            element: <JobDetail />,
          },
          {
            path: APP_ROUTES.JOB.EDIT.path,
            element: <EditJob />,
          },
          {
            path: APP_ROUTES.JOB.PAYMENT.path,
            element: <PaymentJobs />,
          },
          {
            path: '*',
            element: <Navigate to={APP_ROUTES.JOB.to} replace />,
          },
        ],
      },
      {
        path: APP_ROUTES.CREDITS.path,
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <OverviewCredits />,
          },
          {
            path: APP_ROUTES.CREDITS.BUY_PACKAGE.path,
            element: <BuyCredits />,
          },
          {
            path: APP_ROUTES.CREDITS.PAYMENT.path,
            element: <PaymentCredits />,
          },
          {
            path: '*',
            element: <Navigate to={APP_ROUTES.CREDITS.to} replace />,
          },
        ],
      },
      {
        path: APP_ROUTES.PROFILE.path,
        element: <EditProfile />,
      },
      {
        path: '*',
        element: <Navigate to={APP_ROUTES.OVERVIEW.to} replace />,
      },
    ],
  },
];

function ParentFeature() {
  const routes = useRoutes(configRoutes);
  return <>{routes}</>;
}

export default ParentFeature;
